import * as constants from '../constants';
import type { Action } from '../state-types';
import { AuthState } from 'loot-core/client/state-types/auth';

export const initialState: AuthState = {
  isAuthenticated: null,
  hasRemoteAccount: null,
  username: null,
  billingStatus: {
    isActive: null,
  },
};

export function update(state = initialState, action: Action): AuthState {
  switch (action.type) {
    case constants.SET_AUTH_STATE:
      return {
        ...state,
        ...action.state,
      };

    default:
  }
  return state;
}
